import { ComponentRef } from "@angular/core";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Coupon } from "src/app/services/dto/orwi-store";
import { GlobalService } from "src/app/services/global.service";
import { CouponService } from "src/app/services/store/coupon.service";
import { OrwiScratchComponent } from "../orwi-scratch.component";

import { ScratchStore } from "./scratch.store";

@Injectable({ providedIn: "root" })
export class ScratchService {
  component: ComponentRef<OrwiScratchComponent>;
  scratchLoaded = new BehaviorSubject("")
  constructor(
    private cs: CouponService,
    private glb: GlobalService,
    private scratchStore: ScratchStore
  ) {}

  async init(coupon: Coupon) {
    this.glb.showLoading();
    await this.cs.couponImage(coupon.id).then((o: any) => {
      this.glb.closeLoading();
      this.scratchStore.update({
        giftImage: o.base64,
        name: coupon.name,
        desc: coupon.description,
        coupon: coupon,
      });
    });
  }
}
